import eventBus from '~/composables/eventBusGtm';

export default defineNuxtPlugin(() => {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];

        eventBus.on('trackEvent', (payload: any) => {
            window.dataLayer.push(payload);
        });
    }
});